module.exports = __webpack_public_path__ + "img/background1.1875548e.jpg";